import { IRequestConfig } from "angular";
import { appModule } from "../../app/app-module";
import { utilsModule } from "../utils-module";

utilsModule.factory('authErrorInterceptor', ['$q','$rootScope','localStorageService',function ($q:any,$rootScope:any,localStorageService:any) {    
    return {
        responseError: function(config:IRequestConfig) {
           var accessToken = window.localStorage.getItem('$LoopBack$accessTokenId');
           var isLogged = (accessToken != undefined) && (accessToken != "");

           if(isLogged && (<any>config).status == 401){
               $rootScope.$emit("auth_error");
               console.log(config);
               return $q.resolve(config);
           }else{
               return $q.reject(config)
           }
            
        }
    }
}]);